import { useState, useEffect } from 'react';
import api from '../services/api';

export default function useBookmark(type, id) {
  const [isBookmarked, setIsBookmarked] = useState(false);
  const [loading, setLoading] = useState(false);

  const toggleBookmark = async () => {
    try {
      setLoading(true);
      const response = await api.post('/bookmarks/toggle', {
        type,
        id,
      });
      
      setIsBookmarked(response.data.is_bookmarked);
      
      return response.data;
    } catch (error) {
      console.error('Failed to toggle bookmark:', error);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  return {
    isBookmarked,
    toggleBookmark,
    loading,
  };
}
